<div *ngIf="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animation-fade-in  ">
    <div
        class="bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh] animation-slide-up relative border border-transparent dark:border-slate-800">

        <!-- Decoration BG -->
        <div
            class="absolute top-0 right-0 w-64 h-64 bg-amber-200 dark:bg-amber-500/10 rounded-full blur-[80px] opacity-20 -mr-20 -mt-20 pointer-events-none">
        </div>

        <!-- Header -->
        <div
            class="px-8 py-6 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-white/80 dark:bg-slate-900/80 backdrop-blur-md sticky top-0 z-10">
            <div class="flex items-center gap-4 min-w-0">
                <div
                    class="w-12 h-12 shrink-0 rounded-2xl bg-amber-50 dark:bg-amber-900/30 text-amber-500 dark:text-amber-400 flex items-center justify-center shadow-sm ring-1 ring-amber-100 dark:ring-amber-500/20">
                    <span class="material-icons text-2xl">ev_station</span>
                </div>
                <div class="min-w-0">
                    <h3 class="text-xl font-extrabold text-slate-800 dark:text-white tracking-tight">
                        รายละเอียดเครื่องชาร์จ</h3>
                    <div class="flex flex-wrap items-center gap-2 text-sm text-slate-500 dark:text-slate-400 font-medium mt-1">
                        <span
                            class="bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded text-xs font-bold text-slate-600 dark:text-slate-300">{{
                            data?.siteEv
                            || '-' }}</span>
                        <span class="text-xs font-bold text-slate-600 dark:text-slate-400">ช่องชาร์จ :</span>
                        <span>{{ data?.spaceCode || '-' }}</span>
                        <span *ngIf="data?.licensePlate" class="text-xs font-bold text-slate-600 dark:text-slate-400">· ทะเบียน {{ data.licensePlate }}</span>
                    </div>
                    <div class="mt-1.5 flex flex-col gap-0.5 text-[11px] font-semibold text-slate-400 dark:text-slate-500">
                        <span class="truncate" [title]="data?.historyUuid || ''">History UID: {{ data?.historyUuid || '-' }}</span>
                        <span class="truncate" [title]="evDetail?.uid || ''">line_id: {{ evDetail?.uid || '-' }}</span>
                    </div>
                    <div *ngIf="!isLoading && evDetail"
                        class="mt-2 flex sm:hidden items-center gap-2">
                        <div class="px-2.5 py-1.5 rounded-xl bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50">
                            <span class="text-[10px] font-bold text-blue-500">kWh </span>
                            <span class="text-xs font-black text-blue-700 dark:text-blue-300 tabular-nums">{{ totalChargingKwh | number:'1.2-2' }}</span>
                        </div>
                        <div class="px-2.5 py-1.5 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/50">
                            <span class="text-[10px] font-bold text-amber-600">฿ </span>
                            <span class="text-xs font-black text-amber-700 dark:text-amber-300 tabular-nums">{{ totalChargingAmount | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center gap-3 shrink-0">
                <div *ngIf="!isLoading && evDetail"
                    class="hidden sm:flex items-center gap-2">
                    <div
                        class="px-3 py-2 rounded-2xl bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50 min-w-[110px]">
                        <div class="text-[10px] font-bold uppercase tracking-wider text-blue-500/80 dark:text-blue-400/80">
                            พลังงานรวม
                        </div>
                        <div class="mt-0.5 text-sm font-black text-blue-700 dark:text-blue-300 tabular-nums">
                            {{ totalChargingKwh | number:'1.2-2' }}
                            <span class="text-[11px] font-bold opacity-70">kWh</span>
                        </div>
                    </div>
                    <div
                        class="px-3 py-2 rounded-2xl bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/50 min-w-[110px]">
                        <div class="text-[10px] font-bold uppercase tracking-wider text-amber-600/80 dark:text-amber-400/80">
                            เงินรวม
                        </div>
                        <div class="mt-0.5 text-sm font-black text-amber-700 dark:text-amber-300 tabular-nums">
                            {{ totalChargingAmount | number:'1.2-2' }}
                            <span class="text-[11px] font-bold opacity-70">฿</span>
                        </div>
                    </div>
                </div>
                <button type="button" (click)="reloadDetail()" [disabled]="isLoading || !data?.id"
                    title="ดึงข้อมูลใหม่"
                    class="w-10 h-10 shrink-0 rounded-full flex items-center justify-center hover:bg-amber-50 dark:hover:bg-amber-900/30 text-slate-400 dark:text-slate-500 hover:text-amber-600 dark:hover:text-amber-400 transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
                    <span class="material-icons" [class.animate-spin]="isLoading">refresh</span>
                </button>
                <button type="button" (click)="closeModal()"
                    class="w-10 h-10 shrink-0 rounded-full flex items-center justify-center hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-400 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 transition-all active:scale-95">
                    <span class="material-icons">close</span>
                </button>
            </div>
        </div>

        <!-- Body -->
        <div class="p-8 overflow-y-auto custom-scrollbar relative">

            <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20">
                <div
                    class="w-12 h-12 border-4 border-amber-200 dark:border-amber-500/20 border-t-amber-500 dark:border-t-amber-500 rounded-full animate-spin mb-4">
                </div>
                <p class="text-slate-400 dark:text-slate-500 text-sm font-bold animate-pulse">กำลังโหลดข้อมูล...</p>
            </div>

            <div *ngIf="!isLoading && evDetail" class="space-y-8">

                <!-- Main Info Section -->
                <div class="flex flex-col lg:flex-row gap-6">
                    <!-- User Info Card -->
                    <div
                        class="flex-1 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] dark:shadow-none border border-slate-100 dark:border-slate-700 relative overflow-hidden group hover:shadow-md transition-all">
                        <div class="absolute top-0 right-0 p-4 opacity-50 dark:opacity-20">
                            <span
                                class="material-icons text-8xl text-slate-50 dark:text-slate-700 -mr-4 -mt-4">person</span>
                        </div>

                        <div class="relative z-10">
                            <div class="flex justify-between items-start mb-4">
                                <h4
                                    class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider flex items-center gap-2">
                                    <span class="w-1.5 h-1.5 rounded-full bg-amber-400 dark:bg-amber-500"></span>
                                    ข้อมูลผู้ใช้งาน
                                </h4>
                            </div>

                            <div class="space-y-4">
                                <div>
                                    <label
                                        class="text-xs text-slate-400 dark:text-slate-500 font-medium mb-1 block">ชื่อ -
                                        นามสกุล</label>
                                    <div class="font-bold text-slate-800 dark:text-slate-200 text-lg">{{ evDetail.name
                                        || '-' }}</div>
                                </div>

                                <div>
                                    <label
                                        class="text-xs text-slate-400 dark:text-slate-500 font-medium mb-1 block">เบอร์โทรศัพท์</label>
                                    <div class="font-bold text-slate-800 dark:text-slate-200 text-lg font-mono">{{
                                        evDetail.phone || '-' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Stats Card -->
                    <div
                        class="flex-1 bg-gradient-to-br from-amber-50 dark:from-slate-800 to-white dark:to-slate-900 rounded-3xl p-6 border border-amber-100 dark:border-slate-700 relative overflow-hidden flex flex-col justify-center items-center text-center shadow-sm dark:shadow-none">
                        <div class="mb-2">
                            <span
                                class="w-12 h-12 rounded-full bg-white dark:bg-slate-800 text-amber-500 dark:text-amber-400 flex items-center justify-center shadow-sm dark:shadow-none mx-auto ring-4 ring-amber-50/50 dark:ring-amber-500/10">
                                <span class="material-icons">account_balance_wallet</span>
                            </span>
                        </div>
                        <h4
                            class="text-amber-600/70 dark:text-amber-500/80 text-sm font-bold uppercase tracking-wider mb-2">
                            ยอดเงินคงเหลือ
                            (Amount)</h4>
                        <div class="text-5xl font-black text-slate-800 dark:text-white tracking-tight">
                            {{ evDetail.amount | number:'1.2-2' }}
                            <span class="text-xl text-slate-400 dark:text-slate-500 font-medium">฿</span>
                        </div>
                        <div class="mt-6 w-full">
                            <button (click)="checkStatus()" [disabled]="isCheckingStatus"
                                class="w-full py-3 bg-white dark:bg-slate-800 border border-amber-200 dark:border-slate-600 text-amber-600 dark:text-amber-400 hover:bg-amber-500 hover:dark:bg-amber-500 hover:border-amber-500 hover:text-white rounded-xl font-bold transition-all shadow-sm flex items-center justify-center gap-2 group disabled:opacity-70 disabled:cursor-not-allowed">
                                <span class="material-icons group-hover:animate-spin"
                                    *ngIf="!isCheckingStatus">sync</span>
                                <span class="material-icons animate-spin"
                                    *ngIf="isCheckingStatus">hourglass_empty</span>
                                {{ isCheckingStatus ? 'กำลังตรวจสอบ...' : 'ตรวจสอบสถานะตู้ชาร์จ' }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Vehicle Share -->
                <div>
                    <h4 class="text-slate-800 dark:text-white text-lg font-bold mb-4 flex items-center gap-2">
                        <span class="material-icons text-emerald-500 dark:text-emerald-400">group</span>
                        การแชร์ทะเบียน (Vehicle Share)
                    </h4>

                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] dark:shadow-none border border-slate-100 dark:border-slate-700 p-5">
                        <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
                            <div>
                                <span class="text-xs font-bold uppercase tracking-wider text-slate-400">สถานะ</span>
                                <div class="mt-1">
                                    <span *ngIf="shareInfo?.isShared"
                                        class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
                                        <span class="material-icons text-sm">check_circle</span>
                                        แชร์แล้ว
                                    </span>
                                    <span *ngIf="!shareInfo?.isShared"
                                        class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300">
                                        <span class="material-icons text-sm">person_off</span>
                                        ไม่ได้แชร์
                                    </span>
                                </div>
                            </div>
                            <div class="text-right text-sm text-slate-500 dark:text-slate-400">
                                <div>ทะเบียน {{ shareInfo?.plateNumber || data?.licensePlate || '-' }}</div>
                                <div *ngIf="shareInfo?.vehicleId" class="text-xs mt-0.5">vehicle_id: {{ shareInfo?.vehicleId }}</div>
                            </div>
                        </div>

                        <ng-container *ngIf="shareInfo?.isShared && shareInfo?.activeGroup as group; else noShareDetail">
                            <div class="rounded-xl bg-slate-50 dark:bg-slate-900/60 border border-slate-100 dark:border-slate-700 p-4 mb-4">
                                <span class="text-xs font-bold uppercase tracking-wider text-slate-400">เจ้าของกลุ่ม</span>
                                <div class="mt-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                                    <span class="font-bold text-slate-700 dark:text-slate-200">{{ group.ownerName || '-' }}</span>
                                    <span class="text-sm text-slate-500 dark:text-slate-400">{{ group.ownerPhone || '-' }}</span>
                                </div>
                                <div *ngIf="group.ownerUid" class="mt-1 text-[11px] font-semibold text-slate-400 break-all">
                                    line_id: {{ group.ownerUid }}
                                </div>
                            </div>

                            <div class="flex items-center justify-between mb-3">
                                <h5 class="font-bold text-slate-700 dark:text-slate-200 text-sm">สมาชิกที่แชร์</h5>
                                <span class="px-2.5 py-1 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 text-xs font-bold">
                                    {{ activeShareMembers.length | number }} คน
                                </span>
                            </div>

                            <div *ngIf="activeShareMembers.length > 0; else noShareMembers"
                                class="divide-y divide-slate-100 dark:divide-slate-700 border border-slate-100 dark:border-slate-700 rounded-xl overflow-hidden">
                                <div *ngFor="let member of activeShareMembers"
                                    class="flex items-center gap-3 p-3 bg-white dark:bg-slate-800">
                                    <div
                                        class="w-9 h-9 shrink-0 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300 flex items-center justify-center font-bold text-sm">
                                        {{ member.name ? member.name.charAt(0) : '?' }}
                                    </div>
                                    <div class="min-w-0 flex-1">
                                        <div class="flex items-center gap-2 flex-wrap">
                                            <span class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ member.name || 'ไม่ระบุชื่อ' }}</span>
                                            <span class="px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-300">
                                                {{ member.role || 'member' }}
                                            </span>
                                        </div>
                                        <div class="mt-0.5 text-xs text-slate-400 dark:text-slate-500 truncate">
                                            {{ member.phone || '-' }} · {{ member.uid || '-' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #noShareMembers>
                                <div class="py-8 text-center rounded-xl border border-dashed border-slate-200 dark:border-slate-700 text-slate-400 text-sm">
                                    ไม่พบสมาชิกที่ใช้งานอยู่
                                </div>
                            </ng-template>
                        </ng-container>

                        <ng-template #noShareDetail>
                            <p class="text-sm text-slate-400 dark:text-slate-500">
                                ทะเบียนนี้ไม่มีกลุ่มแชร์ที่ active — ไม่มีสมาชิกอื่นใช้รถคันนี้ร่วมกัน
                            </p>
                        </ng-template>
                    </div>
                </div>

                <!-- History Table Section -->
                <div>
                    <h4 class="text-slate-800 dark:text-white text-lg font-bold mb-4 flex items-center gap-2">
                        <span class="material-icons text-amber-500 dark:text-amber-400">history</span>
                        ประวัติการชาร์จ (Charging History)
                    </h4>

                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] dark:shadow-none border border-slate-100 dark:border-slate-700 overflow-hidden">
                        <div class="overflow-x-auto">
                            <table class="w-full text-sm text-left">
                                <thead
                                    class="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-100 dark:border-slate-700 text-slate-400 dark:text-slate-500 font-bold text-xs uppercase">
                                    <tr>
                                        <th class="px-6 py-4 whitespace-nowrap">วัน-เวลา เริ่ม</th>
                                        <th class="px-6 py-4 whitespace-nowrap">วัน-เวลา สิ้นสุด</th>
                                        <th class="px-6 py-4 text-center whitespace-nowrap">ระยะเวลา</th>
                                        <th class="px-6 py-4 text-center whitespace-nowrap">พลังงาน (kWh)</th>
                                        <th class="px-6 py-4 text-right whitespace-nowrap">จำนวนเงิน</th>
                                        <th class="px-6 py-4 text-center whitespace-nowrap">สถานะ</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-50 dark:divide-slate-700/50">
                                    <tr *ngFor="let history of evDetail.evChargerHistoryResponses"
                                        class="hover:bg-amber-50/30 dark:hover:bg-amber-500/5 transition-colors">
                                        <td
                                            class="px-6 py-4 text-slate-600 dark:text-slate-300 font-medium whitespace-nowrap">
                                            {{
                                            formatDate(history.chargingStart?.toString() || '') }}</td>
                                        <td
                                            class="px-6 py-4 text-slate-600 dark:text-slate-300 font-medium whitespace-nowrap">
                                            {{
                                            formatDate(history.chargingEnd?.toString() || '') }}</td>
                                        <td
                                            class="px-6 py-4 text-center text-slate-500 dark:text-slate-400 font-mono whitespace-nowrap">
                                            {{
                                            history.totalTime }} นาที</td>
                                        <td class="px-6 py-4 text-center whitespace-nowrap">
                                            <span
                                                class="bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 px-2 py-1 rounded-lg font-bold text-xs">{{
                                                history.chargingKwh }} kWh</span>
                                        </td>
                                        <td
                                            class="px-6 py-4 text-right font-bold text-slate-800 dark:text-slate-200 whitespace-nowrap">
                                            {{
                                            history.amount | number:'1.2-2' }}</td>
                                        <td class="px-6 py-4 text-center whitespace-nowrap">
                                            <span class="px-2 py-1 rounded-full text-xs font-bold"
                                                [ngClass]="getStatusClass(history.jobStatus)">
                                                <span class="w-1.5 h-1.5 rounded-full bg-current"></span>
                                                {{ getStatusLabel(history.jobStatus) }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!evDetail.evChargerHistoryResponses.length">
                                        <td colspan="6"
                                            class="px-6 py-12 text-center text-slate-400 dark:text-slate-500 italic bg-slate-50/30 dark:bg-slate-900/20">
                                            <span
                                                class="material-icons text-3xl mb-2 opacity-30 block">history_toggle_off</span>
                                            ไม่มีประวัติการชาร์จ
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Member Action Log -->
                <div>
                    <h4 class="text-slate-800 dark:text-white text-lg font-bold mb-4 flex items-center gap-2">
                        <span class="material-icons text-sky-500 dark:text-sky-400">receipt_long</span>
                        ประวัติการกระทำสมาชิก (Member Action Log)
                    </h4>

                    <div
                        class="bg-white dark:bg-slate-800 rounded-2xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] dark:shadow-none border border-slate-100 dark:border-slate-700 overflow-hidden">
                        <div class="overflow-x-auto">
                            <table class="w-full text-sm text-left">
                                <thead
                                    class="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-100 dark:border-slate-700 text-slate-400 dark:text-slate-500 font-bold text-xs uppercase">
                                    <tr>
                                        <th class="px-4 py-3 whitespace-nowrap">เวลา</th>
                                        <th class="px-4 py-3 whitespace-nowrap">Action</th>
                                        <th class="px-4 py-3 text-center whitespace-nowrap">ผล</th>
                                        <th class="px-4 py-3 whitespace-nowrap">ทะเบียน</th>
                                        <th class="px-4 py-3 whitespace-nowrap">ข้อความ</th>
                                        <th class="px-4 py-3 text-center whitespace-nowrap">รายละเอียด</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-50 dark:divide-slate-700/50">
                                    <ng-container *ngFor="let log of pagedActionLogs">
                                        <tr class="hover:bg-sky-50/30 dark:hover:bg-sky-500/5 transition-colors">
                                            <td class="px-4 py-3 text-slate-600 dark:text-slate-300 font-medium whitespace-nowrap text-xs">
                                                {{ formatDate(log.createDate) }}
                                            </td>
                                            <td class="px-4 py-3 whitespace-nowrap">
                                                <div class="font-bold text-slate-700 dark:text-slate-200 text-xs">{{ actionTypeLabel(log.actionType) }}</div>
                                                <div class="text-[10px] text-slate-400 font-mono">{{ log.actionType }}</div>
                                            </td>
                                            <td class="px-4 py-3 text-center whitespace-nowrap">
                                                <span class="px-2 py-1 rounded-full text-[11px] font-bold ring-1"
                                                    [ngClass]="resultClass(log.result)">
                                                    {{ log.result || '-' }}
                                                </span>
                                            </td>
                                            <td class="px-4 py-3 font-mono text-xs text-slate-600 dark:text-slate-300 whitespace-nowrap">
                                                {{ log.licensePlate || '-' }}
                                            </td>
                                            <td class="px-4 py-3 text-xs text-slate-500 dark:text-slate-400 max-w-[220px] truncate"
                                                [title]="log.messageTh || log.messageEn || ''">
                                                {{ log.messageTh || log.messageEn || log.failReasonCode || '-' }}
                                            </td>
                                            <td class="px-4 py-3 text-center">
                                                <button type="button" (click)="toggleLogDetail(log.id)"
                                                    class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-sky-500 hover:bg-sky-50 dark:hover:bg-sky-900/20 transition-all cursor-pointer">
                                                    <span class="material-icons text-lg">{{ expandedLogId === log.id ? 'expand_less' : 'expand_more' }}</span>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr *ngIf="expandedLogId === log.id" class="bg-slate-50/80 dark:bg-slate-900/40">
                                            <td colspan="6" class="px-4 py-4">
                                                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
                                                    <div>
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">line_uid</span>
                                                        <div class="mt-0.5 font-mono text-slate-600 dark:text-slate-300 break-all">{{ log.lineUid || '-' }}</div>
                                                    </div>
                                                    <div>
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">history_uid</span>
                                                        <div class="mt-0.5 font-mono text-slate-600 dark:text-slate-300 break-all">{{ log.historyUid || '-' }}</div>
                                                    </div>
                                                    <div *ngIf="log.licensePlateBefore || log.licensePlateAfter">
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">ทะเบียนก่อน → หลัง</span>
                                                        <div class="mt-0.5 font-mono text-slate-600 dark:text-slate-300">
                                                            {{ log.licensePlateBefore || '-' }} → {{ log.licensePlateAfter || '-' }}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">external</span>
                                                        <div class="mt-0.5 text-slate-600 dark:text-slate-300">
                                                            {{ log.externalApi || '-' }} · {{ log.externalResultCode || '-' }}
                                                            <span *ngIf="log.externalMessage"> · {{ log.externalMessage }}</span>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="log.requestPayload" class="md:col-span-2">
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">request</span>
                                                        <pre class="mt-1 p-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 overflow-x-auto text-[11px] text-slate-600 dark:text-slate-300 whitespace-pre-wrap break-all">{{ log.requestPayload }}</pre>
                                                    </div>
                                                    <div *ngIf="log.responsePayload" class="md:col-span-2">
                                                        <span class="text-slate-400 font-bold uppercase tracking-wider">response</span>
                                                        <pre class="mt-1 p-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 overflow-x-auto text-[11px] text-slate-600 dark:text-slate-300 whitespace-pre-wrap break-all">{{ log.responsePayload }}</pre>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <tr *ngIf="!actionLogs.length">
                                        <td colspan="6"
                                            class="px-6 py-12 text-center text-slate-400 dark:text-slate-500 italic bg-slate-50/30 dark:bg-slate-900/20">
                                            <span class="material-icons text-3xl mb-2 opacity-30 block">receipt_long</span>
                                            ยังไม่มี Member Action Log สำหรับรายการนี้
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div *ngIf="actionLogs.length"
                            class="px-4 py-3 border-t border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/30">
                            <span class="text-xs font-medium text-slate-500">
                                แสดง {{ actionLogStartIndex }} - {{ actionLogEndIndex }} จาก {{ actionLogs.length }} รายการ
                                <span class="text-slate-400">· {{ actionLogPageSize }} / หน้า</span>
                            </span>
                            <div class="flex items-center gap-1.5">
                                <button type="button" (click)="setActionLogPage(actionLogPage - 1)"
                                    [disabled]="actionLogPage <= 1"
                                    class="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-sky-500 disabled:opacity-30 transition-all cursor-pointer bg-white dark:bg-slate-800">
                                    <span class="material-icons text-sm">chevron_left</span>
                                </button>
                                <button type="button" *ngFor="let p of actionLogPages" (click)="setActionLogPage(p)"
                                    class="w-8 h-8 flex items-center justify-center rounded-lg text-xs font-bold transition-all cursor-pointer"
                                    [ngClass]="p === actionLogPage
                                        ? 'bg-sky-500 text-white shadow-sm'
                                        : 'text-slate-600 dark:text-slate-300 hover:bg-sky-50 dark:hover:bg-slate-700 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700'">
                                    {{ p }}
                                </button>
                                <button type="button" (click)="setActionLogPage(actionLogPage + 1)"
                                    [disabled]="actionLogPage >= actionLogTotalPages"
                                    class="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 text-slate-500 hover:text-sky-500 disabled:opacity-30 transition-all cursor-pointer bg-white dark:bg-slate-800">
                                    <span class="material-icons text-sm">chevron_right</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>

<app-modal-ev-charger-check-status [isOpen]="isCheckStatusModalOpen" [data]="checkStatusData"
    (onClose)="closeCheckStatusModal()">
</app-modal-ev-charger-check-status>
